import React from 'react';
import styled from 'styled-components';
import { DEFAULT_THEME_COLOR } from 'appenv';
import { useSelector } from 'react-redux';

const BannerProfileButton = styled.button<{ color: string }>`
  background: ${({ color }: { color: string }) => color};
  border-radius: 4px;
  font-family: Lato, sans-serif;
  border: 0;
  display: block;
  color: #FFF;
  padding: 8px 16px;
  min-height: 32px;
  align-self: flex-start;
  text-decoration: unset;
  cursor: pointer;
`;

export interface ViewMoreButtonProps {
  handleClick: (type: string) => void;
  className?: string;
}

const ViewMoreButton: React.FC<ViewMoreButtonProps> = ({
  handleClick,
  className = '',
}: ViewMoreButtonProps) => {
  const { themeColor } = useSelector((s: any) => s.eventConfigs);
  return (
    <BannerProfileButton
      className={className}
      onClick={() => handleClick('desk')}
      color={themeColor || DEFAULT_THEME_COLOR}
    >
      View More
    </BannerProfileButton>
  );
};

export default ViewMoreButton;
